import { render, staticRenderFns } from "./ProductizationOtoModal.vue?vue&type=template&id=d5058daa&"
import script from "./ProductizationOtoModal.vue?vue&type=script&lang=js&"
export * from "./ProductizationOtoModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductizationOtoModal.vue?vue&type=style&index=0&id=d5058daa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports